module.exports = __webpack_public_path__ + "static/media/screenshot(47).6d784607.jpg";